// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2bKNQ","label":"Labeled_label__2QavH","divider":"Labeled_divider__1lYBk"};